// extracted by mini-css-extract-plugin
module.exports = {"userDetails":"mailDetails_userDetails__z65X0","chipsList":"mailDetails_chipsList__1ikYK"};